import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AclPermissionDetail } from '@y42/acl/models';
import { createAclPermissionDetail } from '@y42/acl/util/create-acl-permission-detail';
import { connectState, InputObservable, trackByValue } from '@y42/angular/util';
import { Observable } from 'rxjs';
import { toolbarBackdropClass } from '../../constants';

@UntilDestroy()
@Component({
  selector: 'y42-insert-sticky-note-button',
  templateUrl: './insert-sticky-note-button.component.html',
  styleUrls: ['./insert-sticky-note-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsertStickyNoteButtonComponent {
  @Input() active = false;

  @Input()
  @InputObservable()
  isCanvasEditable = createAclPermissionDetail({ allowed: false });
  private readonly isCanvasEditable$!: Observable<AclPermissionDetail>;

  @Output() readonly selectTool = new EventEmitter<string>();

  protected readonly stickyNotesColors = stickyNotesColors;
  protected readonly defaultColor = defaultStickyNoteColor;
  protected readonly toolbarBackdropClass = toolbarBackdropClass;
  protected readonly trackByValue = trackByValue;

  readonly state = connectState(this, {
    isCanvasEditable: this.isCanvasEditable$,
  });

  protected onSelectStickyNote(color?: string) {
    this.selectTool.emit(color);
  }
}

const defaultStickyNoteColor = '#F5D128';
const stickyNotesColors = [
  '#F5F6F8',
  '#FFF1CC',
  defaultStickyNoteColor,
  '#FF9D48',
  '#DE726F',
  '#EA94BB',
  '#BE88C7',
  '#7B92FF',
  '#67C6C0',
  '#A6CCF5',
  '#C9DF56',
  '#93D275',
];
